/* tslint:disable */
/* eslint-disable */
/**
 * CyberWell Aegis API
 * Multi-tenant case management API with JWT auth, RBAC (Casbin), audit logging, and tenant isolation.
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { EntityRelationship } from './EntityRelationship';
import {
    EntityRelationshipFromJSON,
    EntityRelationshipFromJSONTyped,
    EntityRelationshipToJSON,
    EntityRelationshipToJSONTyped,
} from './EntityRelationship';

/**
 * 
 * @export
 * @interface RelationshipListResponse
 */
export interface RelationshipListResponse {
    /**
     * 
     * @type {boolean}
     * @memberof RelationshipListResponse
     */
    success?: boolean;
    /**
     * 
     * @type {Array<EntityRelationship>}
     * @memberof RelationshipListResponse
     */
    relationships?: Array<EntityRelationship>;
    /**
     * 
     * @type {number}
     * @memberof RelationshipListResponse
     */
    total?: number;
    /**
     * 
     * @type {number}
     * @memberof RelationshipListResponse
     */
    page?: number;
    /**
     * 
     * @type {number}
     * @memberof RelationshipListResponse
     */
    pageSize?: number;
    /**
     * 
     * @type {number}
     * @memberof RelationshipListResponse
     */
    totalPages?: number;
}

/**
 * Check if a given object implements the RelationshipListResponse interface.
 */
export function instanceOfRelationshipListResponse(value: object): value is RelationshipListResponse {
    return true;
}

export function RelationshipListResponseFromJSON(json: any): RelationshipListResponse {
    return RelationshipListResponseFromJSONTyped(json, false);
}

export function RelationshipListResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): RelationshipListResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'success': json['success'] == null ? undefined : json['success'],
        'relationships': json['relationships'] == null ? undefined : ((json['relationships'] as Array<any>).map(EntityRelationshipFromJSON)),
        'total': json['total'] == null ? undefined : json['total'],
        'page': json['page'] == null ? undefined : json['page'],
        'pageSize': json['pageSize'] == null ? undefined : json['pageSize'],
        'totalPages': json['totalPages'] == null ? undefined : json['totalPages'],
    };
}

export function RelationshipListResponseToJSON(json: any): RelationshipListResponse {
    return RelationshipListResponseToJSONTyped(json, false);
}

export function RelationshipListResponseToJSONTyped(value?: RelationshipListResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'success': value['success'],
        'relationships': value['relationships'] == null ? undefined : ((value['relationships'] as Array<any>).map(EntityRelationshipToJSON)),
        'total': value['total'],
        'page': value['page'],
        'pageSize': value['pageSize'],
        'totalPages': value['totalPages'],
    };
}

